"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alert = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = require("@emotion/react");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_assets_1 = require("@ryerson/frontend.assets");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var AlertSection = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\twidth: auto;\n\tpadding: 10px;\n\t", ";\n"])), function (props) {
  var outline = props.outline,
      outlineColor = props.outlineColor;

  if (outline) {
    return (0, react_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t\tborder: 1px solid ", ";\n\t\t\t\tborder-radius: 2px;\n\t\t\t"])), outlineColor);
  }
});
var alertIcon = (0, react_1.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tmargin-right: 10px;\n\tflex-shrink: 0;\n"])));

var Alert = function Alert(_ref) {
  var children = _ref.children,
      severity = _ref.severity,
      icon = _ref.icon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size,
      _ref$outline = _ref.outline,
      outline = _ref$outline === void 0 ? false : _ref$outline;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _theme$colors$seconda = theme.colors.secondary,
      blue = _theme$colors$seconda.blue,
      red = _theme$colors$seconda.red,
      yellow = _theme$colors$seconda.yellow,
      green = _theme$colors$seconda.green;
  var outlineColor = "";

  switch (severity) {
    case "warn":
      icon = icon || "warning";
      outlineColor = yellow;
      break;

    case "error":
      icon = icon || "error";
      outlineColor = red;
      break;

    case "success":
      icon = icon || "success";
      outlineColor = green;
      break;

    default:
      icon = icon || "info";
      outlineColor = blue;
      break;
  }

  return (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
    children: (0, jsx_runtime_1.jsxs)(AlertSection, {
      outline: outline,
      outlineColor: outlineColor,
      children: [(0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
        icon: icon,
        size: size,
        css: alertIcon
      }), children]
    })
  });
};

exports.Alert = Alert;